import DesCatalogSearchResultsViewModel from 'viewmodel/DesCatalogSearchResultsViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

export default class DesCatalogSearchResults extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogSearchResultsViewModel);
    }

    get viewerSrc() {
        return this.getAttribute('viewerSrc');
    }

    get provider() {
        return this.getAttribute('provider');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get queryString() {
        return this.getAttribute('querystring') || this.getAttribute('query-string')
    }

    get display() {
        return DesBaseCatalogAcc.getDisplayMode(this.getAttribute('display'));
    }

    get contentPath() {
        return this.getAttribute('content-path');
    }

    get limit() {
        const limitStr = this.getAttribute('limit');
        if (limitStr !== null && limitStr.length > 0) {
            return parseInt(this.getAttribute('limit'), 10);
        } else {
            return 50;
        }
    }

    /* Check the attribute value of filter unit if it is other than mm/inch
       then it set to the empty string and default result have shown.
    */
    get filterUnit() {
       return this.getAttribute(DesAccConstants.FILTER_UNIT);
    }

    getProps() {
        return {
            provider: this.provider,
            catalogspaceid: this.catalogspaceId,
            viewerSrc: this.viewerSrc,
            display: this.display,
            contentpath: this.contentPath,
            querystring: this.queryString,
            limit: this.limit,
            filterunit: this.filterUnit
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'provider',
            'viewerSrc', 'display', 'content-path', 'limit', 'query-string', DesAccConstants.FILTER_UNIT];
    }
}

if (!window.customElements.get('des-catalog-search-results')) {
    window.customElements.define('des-catalog-search-results', DesCatalogSearchResults);
}
